import {Text} from 'platform/foundation';

import {is, isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

const isArray = is(Array);
const BULLET_PREFIX = '\u2022 ';

export const getFlagTooltipLabel = (
  labels: Record<string, string>[],
  selectedValue: string | Nullish
) => {
  if (!isArray(labels)) {
    return labels;
  }

  const items = labels.map((item) => item.label ?? item.key ?? null).filter(isNotNil);

  return (
    <>
      {items.map((item) => (
        <Text key={item} size="small" color={selectedValue === item ? 'success' : 'white'}>
          {BULLET_PREFIX} {item}
        </Text>
      ))}
    </>
  );
};
